import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { BACKEND_URL } from "../../constants";


export const CreateCompany = () => {
    const [companyName, setCompanyName] = useState("");
    const [ownerName, setOwnerName] = useState("");
    const [ownerEmail, setOwnerEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    // Extract token from the URL
    const token = new URLSearchParams(location.search).get("token");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (password !== confirmPassword) {
            return setError("Lösenorden matchar inte.");
        }

        const params = {
            companyName,
            ownerName,
            ownerEmail,
            password
        }

        try {
            const { data } = await axios.post(
                `${BACKEND_URL}/create-new-company`,
                { token, params},
                { withCredentials: true }
            );

            if (data.status === "success") {
                setSuccess(true);
                setTimeout(() => navigate("/login"), 500); // Redirect after 1.5 seconds
            } else {
                setError(data.errorText);
            }
        } catch (err) {
            setError("Ett fel uppstod. Försök igen.");
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.textWrapper}>
                <h1 style={styles.mainText}>Välkommen till <span style={styles.brand}>𝙏𝙞𝙢𝐞𝙎𝙢𝙖𝙧𝙩</span></h1>
                <p style={styles.subText}>Ange bolagets namn och den ansvariga för shemaläggningens uppgifter för att komma igång.</p>
            </div>

            <div style={styles.formWrapper}>
                {success ? (
                    <p style={styles.successMessage}>Lösenordet har skapats! Omdirigerar...</p>
                ) : (
                    <form onSubmit={handleSubmit} style={styles.form}>
                        <input
                            type="text"
                            placeholder="Bolagsnamn"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            required
                            style={styles.input}
                        />
                        <input
                            type="text"
                            placeholder="Ägarens namn"
                            value={ownerName}
                            onChange={(e) => setOwnerName(e.target.value)}
                            required
                            style={styles.input}
                        />
                        <input
                            type="email"
                            placeholder="Ägarens e-post"
                            value={ownerEmail}
                            onChange={(e) => setOwnerEmail(e.target.value)}
                            required
                            style={styles.input}
                        />
                        <input
                            type="password"
                            placeholder="Lösenord"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={styles.input}
                        />
                        <input
                            type="password"
                            placeholder="Bekräfta lösenord"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            style={styles.input}
                        />
                        <button type="submit" style={styles.button}>Skapa</button>
                        {error && <p style={styles.errorMessage}>{error}</p>}
                    </form>
                )}
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        background: "linear-gradient(135deg, #1a1a1a, #24478f)",
        padding: "16px",
        textAlign: "center",
    },
    textWrapper: {
        marginBottom: "20px",
        textAlign: "center !important" ,
    },
    mainText: {
        fontSize: "2rem",
        fontWeight: "700",
        color: "#fff",
        marginBottom: "8px",
    },
    brand: {
        color: "#5aa0e0",
        fontSize: "2.5rem"
    },
    subText: {
        fontSize: "1rem",
        color: "#ddd",
        maxWidth: "500px",
        textAlign: "center"
    },
    formWrapper: {
        background: "#fff",
        borderRadius: "8px",
        padding: "24px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        width: "100%",
        maxWidth: "400px",
    },
    form: {
        display: "flex",
        flexDirection: "column",
    },
    input: {
        width: "100%",
        padding: "12px",
        margin: "8px 0",
        border: "1px solid #ccc",
        borderRadius: "4px",
        fontSize: "1rem",
        transition: "border-color 0.3s ease",
    },
    inputFocus: {
        borderColor: "#007bff",
    },
    button: {
        width: "100%",
        padding: "12px",
        backgroundColor: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "4px",
        fontSize: "1rem",
        fontWeight: "600",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
    },
    buttonHover: {
        backgroundColor: "#0056b3",
    },
    errorMessage: {
        color: "red",
        marginTop: "10px",
        fontSize: "0.9rem",
    },
    successMessage: {
        color: "green",
        fontSize: "1rem",
    },
};


